import Link from 'next/link';
import { ArrowRight, Tag } from '@phosphor-icons/react/dist/ssr';
import { getContextualHref } from '@/lib/domains';
import { sized } from '../grocery-utils';
import { dealRule, type StoreDeal } from './home-data';

export function DealsStrip({ deals, slug, sym }: { deals: StoreDeal[]; slug: string; sym: string }) {
  if (!deals.length) return null;
  const href = getContextualHref(slug, '/deals');
  return (
    <section aria-label="Deals" className="gh-wrap gh-section">
      <div className="gh-head">
        <h2 className="gh-h2">Deals</h2>
        <Link href={href} className="gh-link">All deals</Link>
      </div>
      <div className="gh-scroll gh-scroll-deals">
        {deals.slice(0, 8).map((d) => {
          const img = d.products.find((p) => p.imageUrl)?.imageUrl;
          return (
            <Link key={d.id} href={href} className="gh-deal gh-tile">
              <span className="gh-deal-txt">
                <span className="gh-deal-tag"><Tag size={13} aria-hidden /> {d.name}</span>
                <strong>{dealRule(d, sym)}</strong>
                <span className="gh-deal-go">See deal <ArrowRight size={14} aria-hidden /></span>
              </span>
              {img && <img src={sized(img, 240)} alt="" loading="lazy" decoding="async" />}
            </Link>
          );
        })}
      </div>
    </section>
  );
}
